import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { ComplianceStatusEntry } from '../../interfaces/compliance-status.interface';

@Component({
  selector: 'cp-compliance-status',
  templateUrl: './compliance-status.component.html',
  styleUrls: ['./compliance-status.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComplianceStatusComponent {
  @Input() public statuses: Array<ComplianceStatusEntry> = [];
  @Input() public expiryDate!: string;

  constructor(private _router: Router) {}

  public get isNotCompliancePage(): boolean {
    return !this._router.url.startsWith('/compliance');
  }

  public onStatusClick(e: MouseEvent | KeyboardEvent): void {
    if (e instanceof KeyboardEvent && e.key !== 'Enter') return;
    e.stopPropagation();

    this._router.navigate(['/compliance']).then();
  }
}
